import React, { useContext, useEffect, useRef } from "react";
import styles from "./StoryEvgenia.module.scss";
import stylesText from "../../components/Text/Text.module.scss";
import PathContext from "../../context/path";
import MobileContext from "../../context/mobile";
import Cover from '../../components/Cover';
import Figure from '../../components/Figure';
import StoryDate from '../../components/StoryDate';
import Footer from '../../components/Footer';
import MoreStory from '../../components/MoreStory';
import Invite from '../../components/Invite';
import Conclusion from '../../components/Conclusion';
import Quote from '../../components/Quote';
import Test from '../../components/Test/Test';
import Photo from '../../components/Photo';
import Message from '../../components/Message';
import Comment from '../../components/Comment';
import Sticky from '../../components/Sticky';
import StickyEvnegia from '../../components/StickyEvnegia';
const StoryEvgenia = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);

  const refContruction = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 1);
    const wrap = refContruction.current;
    let options = {
      threshold: 0,
      rootMargin: '0% 0% 0% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.animate);
          observer.unobserve(entry.target);
        }
      })
    }, options);
    observer.observe(wrap);

    return () => {
      observer.unobserve(wrap);
    }
  }, []);
  let figureBgArray = [
    'green-light-saw.svg',
    'transparent-saw-evgenia.svg'
  ];
  if (isMobile) {
    figureBgArray = [
      'green-light-saw.svg',
      undefined
    ];
  }
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.cover}>
          <Cover img={'evgenia-img'} name={'Евгения Завершинская'} position={'Менеджер по маркетингу'} text={['Привет! В Р-Фарм у каждого есть свобода выбирать свой путь, проявлять инициативу, отстаивать свою позицию, ошибаться и следовать за своим сердцем.', 'Я работаю здесь 9 лет — за это время не раз чувствовала, как много свободы выбора дает Р-Фарм. И хочу поделиться с вами самыми яркими и важными для меня моментами.']}>
            <>
              <div className={styles.constructions} ref={refContruction}>
                <div className={styles.constructions__row}>

                  <div className={`${styles.construct} ${styles.construct_1}`}>
                    <Figure bg={figureBgArray[0]} form={'circle'}>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_2}`}>
                    <Figure color={"pink"} >
                      <div className={styles.construct__text}>жить,</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_3}`}>
                    <Figure bg={figureBgArray[1]}>
                      <div className={styles.construct__text}>работать,</div>
                    </Figure>
                  </div>
                </div>
                <div className={styles.constructions__row}>
                  <div className={`${styles.construct} ${styles.construct_4}`}>
                    <Figure color={"green"} form={'rect'}>
                      <div className={styles.construct__text}>выбирать свой путь</div>
                    </Figure>
                  </div>
                  <div className={`${styles.construct} ${styles.construct_5}`}>
                    <Figure color={"border"} form={'circle'}>
                    </Figure>
                  </div>
                </div>
              </div>
            </>
          </Cover>
        </div>

        <section data-stage='0' className={`${styles.stage} ${styles.stage_1}`}>
          <div className="container">
            <StoryDate date={'2013 год'} title={'Свобода выбирать\nсвой путь'} color={'red'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_1}`} data-animate={'fade-in-up'}>
              <p>
                2013 год, я только получила высшее образование, но уже работала по специальности в области финансов — на младшей позиции — в компании металлургического профиля.
              </p>
              <p>
                Не планировала что-то менять, но случилось сокращение штата, и я была вынуждена вновь искать себя. Тогда решила обратить внимание на вакансии не только по профилю, но и те, где не нужен опыт.
              </p>
              <p>
                Как я выбрала Р-Фарм:
              </p>
            </div>
            <div className={styles.cards}>
              <div className={styles.cards__inner} data-animate={true} data-animate-mobile={'fade-in-up'}>

                <div className={styles.card} data-animate={'fade-in-left'} data-animate-mobile={'none'}>
                  <div className={styles.card__icon}>
                    <img src={`${path}/img/card-icon-evgenia.svg`} alt="" />
                    1
                  </div>
                  <div className={`${styles.card__title} ${stylesText.lid}`}>Увидела вакансию ассистента в Р-Фарм</div>
                  <div className={styles.card__text}>Она не требовала профильного образования или опыта. Поэтому решила попробовать.</div>
                </div>
                <div className={styles.card} data-animate={'fade-in-left'} data-animate-mobile={'none'} data-animate-delay={'0.2'}>
                  <div className={styles.card__icon}>
                    <img src={`${path}/img/card-icon-evgenia.svg`} alt="" />
                    2
                  </div>
                  <div className={`${styles.card__title} ${stylesText.lid}`}>Прошла собеседование с руководителем</div>
                  <div className={styles.card__text}>Сразу почувствовала себя комфортно. Не могу объяснить это чувство словами — что-то химическое, физическое, ментальное. Будто мы на одной волне.</div>
                </div>
                <div className={styles.card} data-animate={'fade-in-left'} data-animate-mobile={'none'} data-animate-delay={'0.4'}>
                  <div className={styles.card__icon}>
                    <img src={`${path}/img/card-icon-evgenia.svg`} alt="" />
                    3
                  </div>
                  <div className={`${styles.card__title} ${stylesText.lid}`}>Получила оффер</div>
                  <div className={styles.card__text}>После собеседования, поймала себя на мысли, что вот здесь хотела бы работать. И буквально через десять минут мне позвонили и сказали, что готовы сделать оффер. Тогда не верилось, что так бывает!</div>
                </div>
              </div>
            </div>
            <div className={`${styles.quote}`}>
              <Quote text={['Не скажу, что у меня была цель работать именно', 'в фарме, но точно хотелось чего-то нового. И когда', 'на собеседовании в Р-Фарм я почувствовала и дух', 'возможностей, и теплоту, то решила рискнуть.']} textMobile={['Не скажу, что у меня была', 'цель работать именно', 'в фарме, но точно хотелось', 'чего-то нового. И когда', 'на собеседовании', 'в Р-Фарм', 'я почувствовала и дух', 'возможностей, и теплоту,', 'то решила рискнуть.']} color={'red'} />
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_2}`} data-animate={'fade-in-up'}>
              <h3>Сама выбрала направление для развития</h3>
              <p>
              Я пришла на позицию ассистента департамента «Вирусология» — это первая ступенька карьерной лестницы. Работа ассистентом позволяет узнать компанию и познакомиться с разными направлениями. Спустя некоторое время, я поняла, что мне интересен маркетинг. Больше всего вдохновляла команда. Я начала предлагать свою помощь в различных проектах, много слушала, анализировала и думала: а какое бы решение приняла я?
              </p>
              <p>
              Желание работать в маркетинге было огромным, но я понимала, что путь не будет быстрым и легким. Ведь у меня нет ни маркетингового, ни медицинского образования.
              </p>
            </div>
            <div className={styles.scheme}>
              <picture>
                <source media="screen and (max-width: 767px)" srcSet={`${path}/img/evgenia-scheme-mobile.svg`} />
                <img src={`${path}/img/evgenia-scheme.svg`} alt="" />
              </picture>
            </div>
            <div className={`${styles.quote} ${styles.quote_2}`}>
              <Quote text={['Благодаря возможности выбирать, я пробовала новое,', 'училась и развивалась в интересных мне', 'направлениях. Это помогло сохранить запал ', 'и не выгореть за 9 лет.']} textMobile={['Благодаря возможности', 'выбирать, я пробовала новое,', 'училась и развивалась', ' в интересных мне', 'направлениях.', ' Это помогло сохранить', 'запал и не выгореть за 9 лет.']} color={'red'} />
            </div>
          </div>
        </section>

        <section data-stage='1' className={`${styles.stage}`}>
          <div className="container">
            <StoryDate date={'Всегда'} title={'Свобода ошибаться'} color={'red'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_3}`} data-animate={'fade-in-up'}>
              <p>
              Я перфекционист: не люблю допускать ошибки и тяжело их переживаю. Для меня ошибка — всегда боль и самокопание. Как так? Как я здесь вообще могла ошибиться?
              </p>
            </div>
            <div className={`${stylesText.paragraph}`} data-animate={'fade-in-up'}>
              <h3>Р-Фарм прощает ошибки и «вылечивает» мой перфекционизм</h3>
              <p>
              У нас принято действовать двумя способами: если ошибку можно исправить, предлагаем руководителю варианты решений. Если исправить уже нельзя, анализируем ситуацию и продумываем, как не повторить ту же самую ошибку в следующий раз.
              </p>
            </div>

            <div className={`${styles.test} ${styles.test_1}`}>
              <Test
                question={'Я подготовила руководителю презентацию к мероприятию. Мероприятие началось, запускается презентация, и тут я понимаю, что часть текста не отображается. Что делать?'}
                answers={['Ничего. Не такая страшная ошибка, чтобы что-то делать и переживать.', 'Готовиться к разбору полетов у начальника. Стоит уже сейчас придумать достойное оправдание.', 'Разобраться, почему так произошло, сделать выводы, и в следующий раз провести двойную проверку накануне выступления.']}
                rightAnswer={0}
                resultTitles={['Не совсем!', 'Нет, это не путь Р-Фарм',  'Верно! ']}
                resultText={[['Ошибка небольшая, но всё же лучше продумать процесс так, чтобы ее не повторять. Например, просить коллег просматривать следующие презентации перед тем, как отдавать спикеру. Или проверять самим на разных устройствах.', 'Наши ответы не совпали, но всё может измениться в атмосфере Р‑Фарм.'], ['В Р-Фарм не принято ругать за ошибки. Вызов «на ковер» и агрессивный разбор полетов не поможет вернуться в прошлое и всё исправить. Зато способен обидеть. Поэтому в Р-Фарм мы просто подумаем, как не повторить ошибку снова.', 'Наши ответы не совпали, но всё может измениться в атмосфере Р‑Фарм.'], ['Например, можно попросить коллегу проверить готовую презентацию или запустить самим на разных устройствах. Я всегда делаю выводы из ошибок и думаю, как исправить процесс, чтобы такое больше не повторялось. Но при этом не ругаю себя.', 'Наши ответы совпали, была бы рада работать с вами в Р‑Фарм!']]}
                img={'evgenia-test-1'}
                color={'red'}
              />
            </div>
            <div className={`${styles.quote} ${styles.quote_3}`}>
              <Quote text={['Невозможно всегда всё делать без ошибок —', 'мы не роботы. Да и роботы иногда ошибаются. Но разбор', 'полетов и чувство вины тут не помогут. Лучше', 'подумать, как не повторить ошибку снова.']} textMobile={['Невозможно всегда всё', 'делать без ошибок —', 'мы не роботы. Да и роботы', 'иногда ошибаются. Но разбор', 'полетов и чувство вины', 'тут не помогут. Лучше', 'подумать, как не повторить', 'ошибку снова.']} color={'red'} />
            </div>
          </div>
        </section>

        <section data-stage='2' className={`${styles.stage} ${styles.stage_3}`}>
          <div className="container">
            <StoryDate date={'2019 год'} title={'Свобода совмещать\nсемью и работу'} color={'red'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_5}`} data-animate={'fade-in-up'}>
              <p>
              В апреле 2019 года у меня родился сын, и я ушла в декрет. Но уже через полтора месяца поняла, что не могу без работы: мне было скучно, мозг требовал интеллектуальных задач. А еще не хотелось растерять навыки, ведь если выпасть из информационного поля на три года в маркетинге, можно сильно отстать в профессии.
              </p>
            </div>
            <div className={`${styles.photo}`} data-animate={'fade-in-up'}>
              <Photo img={'evgenia-photo-1'} desc={'Евгения со своим сыном'} align={'right'}/>
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_6}`} data-animate={'fade-in-up'}>
              <h3>Узнала, что могу выйти на полставки</h3>
              <p>У меня было ощущение, что в фарме не принято совмещать: либо ты в декрете, либо ты работаешь. Чего-то среднего нет.</p>
              <p>Но в Р-Фарм активно поддерживают концепцию баланса в этом вопросе: если у женщины есть желание и возможность совмещать, и ее работа не предполагает 100% присутствия в офисе или «полях», ей предложат варианты. Узнав об этом, я решила обсудить со своим руководителем работу на полставки.</p>
            </div>
            <div className={styles.chat}>
              <div className={styles.chat__inner}>
                <div className={styles.chat__list}>
                  <Message img={'chat-evgenia'} name={'Евгения'} position={'менеджер по маркетингу'} text={'Добрый день! Я не хотела бы останавливаться на достигнутом, чувствую, что у меня есть силы и время совместить декрет и работу. Знаю, что у нас в компании есть такие кейсы. Могли бы мы это обсудить?'} color={'red'} float={'right'} />
                  <Message img={'chat-placeholder-green'} name={''} position={'Руководитель Евгении'} text={'Женя, привет! Рада тебя слышать! У нас сейчас как раз запускается проект, в котором требуется помощь, и твои компетенции будут нам полезны. Возможна удаленная работа. Скажи, сколько времени ты готова этому посвятить?'} color={'red_transparent'} />
                  <Message img={'chat-evgenia'} name={'Евгения'} position={'менеджер по маркетингу'} text={'Как здорово! Думаю, я могу работать 4 часа в день. Важно ли, в какое время буду сдавать результаты работы? Или можно подстроить график под себя: делать часть утром, а часть вечером?'} color={'red'} float={'right'} emoji={['like', 'green-smile']} />
                  <Message img={'chat-placeholder-green'} name={''} position={'Руководитель Евгении'} text={'Можем сделать гибкий график, и ты сама выстроишь удобный тебе подход. Главное — согласовывать день сдачи проекта и направлять всё в срок. А детали еще обсудим!'}  color={'red_transparent'} emoji={['love', 'evgenia']}/>
                </div>
              </div>
            </div>
            <div className={`${styles.quote} ${styles.quote_4}`}>
              <Quote text={['Такой уровень свободы возможен, когда каждый', 'в команде управляет своим временем, приоритизирует', 'задачи и фокусируется на результате. Без микро-', 'менеджмента и напоминаний о дедлайнах.']} textMobile={['Такой уровень свободы', 'возможен, когда каждый', 'в команде управляет своим', 'временем, приоритизирует', 'задачи и фокусируется', 'на результате. Без микро-', 'менеджмента и напоминаний', 'о дедлайнах.']} color={'red'} />
            </div>
          </div>
        </section>

        <section data-stage='3' className={`${styles.stage} ${styles.stage_4}`}>
          <div className="container">
            <StoryDate date={'2022 год'} title={'Свобода\nпредлагать'} color={'red'} />
            <div className={`${stylesText.paragraph} ${styles.paragraph_7}`} data-animate={'fade-in-up'}>

              <p>Во время моей работы на полставки в Р-Фарм сформировался новый департамент — «Международного маркетинга». </p>
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_8}`} data-animate={'fade-in-up'}>
              <h3>Департамент появился по инициативе сотрудника</h3>
              <p>Новый департамент предложила создать Кира Иванова, вице-президент по собственным брендам. Высшее руководство ее инициативу оценило и одобрило: Р-Фарм как раз активно готовился к выходу одного из своих брендов на международный рынок.</p>
              <p>Проект рос, команда расширялась, и Кира предложила мне присоединиться к новому департаменту в роли менеджера по маркетингу. Задачи были такими: разработка стратегии по выводу продукта на новые рынки, подготовка лонча, материалов, организация участия в международных конференциях. Я согласилась и уже в августе 2021 года вышла на полную ставку. Работаю тут до сих пор: уверена, всё самое интересное еще впереди!</p>
            </div>
            <div className={`${styles.test} ${styles.test_2}`}>
              <Test
                question={'Кира Иванова предложила запустить новый департамент для расширения возможностей Р-Фарм. Как думаете, сложно было согласовать проект?'}
                answers={['Конечно, нужно пройти через десятки руководителей и подписать сотни бумаг.', 'Скорее невозможно. Пока высшее руководтство не скажет, ничего не появится.', 'Может, и легко. Всё зависит от потребностей бизнеса.']}
                rightAnswer={2}
                resultTitles={['Нет! Обошлись без сотни бумаг', 'В Р-Фарм возможно всё', 'Да! Вы правы']}
                resultText={[['Р-Фарм ценит инициативы сотрудников. А бюрократию не любит. Инициатива Киры была актуальна и обоснована, поэтому никаких препятствий ей не создавали, наоборот, поддержали.', 'Главное — быть уверенным в идее, иметь четкое виденье и обосновать свое предложение.', 'Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться.'], ['Р-Фарм ценит инициативы сотрудников. Особенно, если они актуальны — идея Киры была именно такой. У бизнеса как раз появилась потребность продвигать свои препараты на международном уровне. Так что одобрения высшего руководства долго ждать не пришлось. ', 'Наши ответы не совпали, но это не страшно — в атмосфере Р‑Фарм всё может измениться.'], ['Р-Фарм ценит инициативы сотрудников. Особенно, если они актуальны — идея Киры была именно такой. Поэтому всё получилось без лишних сложностей.', 'Главное — быть уверенным в идее, иметь четкое виденье и обосновать свое предложение.', 'Мы мыслим похоже! Была бы рада поработать с вами в Р-Фарм.']]}
                img={'evgenia-test-2'}
                color={'red'}
              />
            </div>
            <div className={`${styles.comment}`}>
              <Comment name={'Кира Иванова'} position={'вице-президент по развитию\nсобственных брендов'} text={'Важно сказать, что я не просто предложила идею: а давайте сделаем? Я разработала стратегию, подтвердила актуальность департамента, просчитала бюджет и риски. Поэтому инициативу одобрили, а мне дали свободу действий. И я делаю всё, чтобы оправдать это доверие.'} img={'evgenia-comment-1'} color={'red'} />
            </div>
            <div className={`${styles.quote} ${styles.quote_5}`}>
              <Quote text={['Запуск департамента международного маркетинга — ', 'отдельный пример свободы в Р-Фарм. Департамент', 'появился не по приказу генерального директора,', 'а по инициативе сотрудника.']} textMobile={['Запуск департамента', 'международного', 'маркетинга — отдельный', 'пример свободы в Р-Фарм.', 'Департамент появился', 'не по приказу генерального', 'директора, а по инициативе', 'сотрудника.']} color={'red'} />
            </div>
            <div className={`${stylesText.paragraph} ${styles.paragraph_9}`} data-animate={'fade-in-up'}>
              <h3>В согласованиях нет места бюрократии</h3>
              <p>Работа нашего департамента международного маркетинга, как и любого другого, тесно связана с медициной. А ещё у нас есть юристы, этика и стандартные операционные процедуры (СОП) — всё это может звучать, как очень сложные и долгие согласования.</p>
              <p>Но и здесь у нас есть свобода, и главное — нацеленность на результат. Каждый понимает, что самое важное — это кросс-функциональное взаимодействие и человеческое общение.</p>
            </div>

          <div className={`${styles.sticky}`}>
            <Sticky mobileEnable={true} height={'200vh'}>
              <StickyEvnegia />
            </Sticky>
          </div>
            <div className={`${styles.quote} ${styles.quote_6}`}>
              <Quote text={['Каждый в команде работает не ради формального', 'соблюдения правил, а так, чтобы точно донести мысль', 'до потребителя и остаться в рамках закона,', 'фактической точности и этики.']} textMobile={['Каждый в команде работает', 'не ради формального', 'соблюдения правил, а так,', 'чтобы точно донести мысль', 'до потребителя и остаться', 'в рамках закона, фактической', 'точности и этики.']} color={'red'} />
            </div>
          </div>
        </section>

        <div className={styles.final}>
          <div className="container">
            <div className={styles.conclusion}>
              <Conclusion img={'evgenia-img'} text={['Р-Фарм дает не только операционную и творческую свободу в работе, но и на глобальном уровне — за пределами компании.', 'В 2021 году Р-Фарм оценил результаты моей работы и дал возможность роста. Это позволило мне исполнить давнюю мечту: организовать переезд родителей из родного Магнитогорска в Москву.','Я приехала в Москву в 2007 году учиться и с того момента мечтала, чтобы родители были рядом. Мы очень близки, и их переезд был моей глобальной личной целью. И в том числе благодаря возможностям, которые дает Р-Фарм, я этой цели достигла. А дальше только больше!']} use={'evgenia'}>
                <div className={`${styles.conclusion__construct} ${styles.conclusion__construct_1}`}>
                  <Figure color={'red'} form={'rect'} >
                  Евгения Завершинская
                  </Figure>
                </div>
                <div className={`${styles.conclusion__construct} ${styles.conclusion__construct_2}`}>
                  <Figure bg={"green-light-triangle.svg"} form={'circle'}>
                  </Figure>
                </div>
              </Conclusion>
            </div>
            <div className={styles.invite} data-animate={'fade-in-up'}>
              <Invite color={'red'} title={'Если вы тоже\nцените свободу,'} desc={'не боитесь проявлять инициативу и ошибаться, умеете отстаивать свои решения и мечтать, приходите в Р-Фарм.'} />
            </div>
            <div className={styles.more}>
              <MoreStory color={'red'}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}

export default StoryEvgenia;
